// extracted by mini-css-extract-plugin
export default {"form-input":"input_form-input__GO8MO","form-input__icon":"input_form-input__icon__0Uxrn","form-input__input":"input_form-input__input__cDHpB"};